import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import { PrivateRoute } from "./components/Routing";
import history from "./utils/history";
import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import CustomerList from "./pages/Customers/Customers";
import EmployeeList from "./pages/Employees/Employees";
import EmployeeDetail from "./pages/Employees/EmployeeDetail";
import CustomerDetail from "./pages/Customers/CustomerDetail";
import Role from "./pages/Role/Role";
import Masters from "./pages/Masters/Masters";
import TaskList from "./pages/Tasks/taskList";
import Follwup from "./pages/Follow-up/Followup";
import Document from "./pages/Document/Document";
import Communication from "./pages/Comunication/Communication";
import Auditreport from "./pages/AuditReport/Auditreport";
import Casemanagement from "./pages/Casemanagement/Casemanagement";
import Payment from "./pages/Payment/Payment";
import ProfilePage from "./pages/Profile/ProfilepPage";
import InqauryPage from "./pages/Inquiry/Inquiary";
import InqauryDetailPage from "./pages/Inquiry/InquirydetailPage";

function Routes() {
  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/forgotpassword" component={ForgotPassword} />
        <Route exact path="/resetpassword" component={ResetPassword} />
        <PrivateRoute exact path="/dashboard" component={Dashboard} />
        <PrivateRoute exact path="/profile" component={ProfilePage} />
        <PrivateRoute
          exact
          path="/customers"
          component={CustomerList}
          requiredPermission="read_customers"
        />
        <PrivateRoute
          exact
          path="/inquiriedetail/:id"
          component={InqauryDetailPage}
          requiredPermission="view_inquiry"
        />
        <PrivateRoute
          exact
          path="/inquiary"
          component={InqauryPage}
          requiredPermission="read_inquiry"
        />

        <PrivateRoute
          exact
          path="/customers/:id"
          component={CustomerDetail}
          requiredPermission="view_customers"
        />

        <PrivateRoute
          exact
          path="/employees"
          component={EmployeeList}
          requiredPermission="read_employee"
        />

        <PrivateRoute
          exact
          path="/employees/:id"
          component={EmployeeDetail}
          requiredPermission="view_employee"
        />

        <PrivateRoute
          exact
          path="/tasks"
          component={TaskList}
          requiredPermission="read_task"
        />

        <PrivateRoute
          exact
          path="/roles"
          component={Role}
          requiredPermission="read_role"
        />

        <PrivateRoute
          exact
          path="/masters"
          component={Masters}
          requiredPermission="read_master"
        />

        <PrivateRoute
          exact
          path="/follow-up"
          component={Follwup}
          requiredPermission="read_followup"
        />

        <PrivateRoute
          exact
          path="/document"
          component={Document}
          requiredPermission="read_document"
        />

        <PrivateRoute
          exact
          path="/communication"
          component={Communication}
          requiredPermission="read_communication"
        />

        <PrivateRoute
          exact
          path="/auditreport"
          component={Auditreport}
          requiredPermission="read_audit_report"
        />

        <PrivateRoute
          exact
          path="/casemanagement"
          component={Casemanagement}
          requiredPermission="read_casemanagement"
        />

        <PrivateRoute
          exact
          path="/payment"
          component={Payment}
          requiredPermission="read_paymentrecovery"
        />
      </Switch>
    </Router>
  );
}
export default Routes;
